import { ERROR_INFO } from "./PanelErrorMessage";
import { SUCCESS_INFO } from "./PanelSuccessMessage";

export const PANEL_MESSAGE_DATA = {
  ...ERROR_INFO,
  ...SUCCESS_INFO,
} as const;
